import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PageHeader, Panel, Kpi } from "@/components/app/kit";
import { useFetch } from "@/hooks/useServerList";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { Input1 } from "@/components/fin/kit";
import { SubStatus } from "@/pages/platform/PlatformConfig";
import { fmtDate } from "@/lib/i18n";

const SRC = { default: "défaut", global: "plateforme", country: "pays", plan: "formule", tenant: "cabinet", user: "personnel" };
const OPT = { ttc: "TTC (taxes comprises)", ht: "HT (hors taxes)", half_up: "Au plus proche (0,5 vers le haut)", half_even: "Arrondi bancaire", fr: "Français", en: "Anglais", export_only: "Export uniquement" };
const field = (d) => ({ k: d.key, type: { bool: "bool", int: "number", decimal: "number", enum: "select", text: "textarea" }[d.type] || "text", options: d.type === "enum" ? d.rules.options.map((o) => [o, OPT[o] || o]) : undefined });

const Row = ({ d, onSaved }) => {
  const { can } = useAuth();
  const [v, setV] = useState(d.value);
  const save = async (scope) => { try { await api.put(`/t/config/${d.key}`, { scope, value: v }); toast.success("Préférence enregistrée"); onSaved(); } catch (e) { toast.error(formatApiError(e)); } };
  const editable = (d.tenant_editable && can("settings:manage") && d.scopes.includes("tenant")) || d.scopes.includes("user");
  return (
    <div className="grid md:grid-cols-[1fr_220px_auto] gap-3 items-center border-b border-slate-100 pb-2" data-testid={`tcfg-${d.key}`}>
      <div><p className="text-sm">{d.label}</p><p className="text-xs text-slate-400">Valeur issue de : {SRC[d.source]}{editable ? "" : " · non modifiable par le cabinet"}</p></div>
      <Input1 f={{ ...field(d), readOnly: !editable }} value={v} onChange={setV} disabled={!editable} testid={`tcfg-val-${d.key}`} />
      <div className="flex gap-1">
        {d.tenant_editable && can("settings:manage") && d.scopes.includes("tenant") && <Button size="sm" onClick={() => save("tenant")} data-testid={`tcfg-save-tenant-${d.key}`}>Cabinet</Button>}
        {d.scopes.includes("user") && <Button size="sm" variant="outline" onClick={() => save("user")} data-testid={`tcfg-save-user-${d.key}`}>Pour moi</Button>}
      </div>
    </div>
  );
};

export default function Subscription() {
  const { data: s } = useFetch("/t/subscription");
  const { data: cfg, reload } = useFetch("/t/config");
  return (
    <div data-testid="tenant-subscription">
      <PageHeader eyebrow="Cabinet" title="Abonnement et préférences" subtitle="Votre formule et les paramètres hérités de la plateforme, du pays et de la formule, personnalisables lorsque c'est autorisé." />
      {s && <div className="grid sm:grid-cols-4 gap-4 mb-6">
        <Kpi label="Formule" value={s.plan_name} testid="sub-plan" /><Kpi label="Statut" value={<SubStatus s={s.status} />} testid="sub-status" />
        <Kpi label="Échéance" value={fmtDate(s.period_end)} testid="sub-period-end" /><Kpi label="Solde dû" value={`${Math.max(0, s.amount_due - s.amount_paid).toLocaleString("fr-FR")} ${s.currency}`} testid="sub-balance" />
      </div>}
      <Panel title="Paramètres et préférences">{(cfg || []).map((d) => <Row key={`${d.key}-${d.source}`} d={d} onSaved={reload} />)}</Panel>
    </div>
  );
}
